export default __webpack_public_path__ + "static/media/logo-25-pure-salt.c1d232fa.png";